module.exports = __webpack_public_path__ + "img/CPTsample1.df45822a.png";